import React, { useEffect, useState } from 'react';
import { CardHeader, Modal, Container, Row, Col, ListGroup, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Card, CardBody, ListGroupItem } from 'reactstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import _ from 'lodash'

import PageTitle from 'components/Title/PageTitle'
import MultilingualRTE from 'components/MultiLangRTE'
import SimpleMultiLang from 'components/Input/simpleMultiLangInput'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import DeleteConfirmationModal from 'components/Modal/deleteConfirmation'
import AlertNotSubscribe from 'components/Alert'
import Lang from 'Lang/General'
import { defaultFormVal, dialogueField, defaultOperatingHours } from './assets'
import OperatingSlotForm from './OperatingSlotForm';
import WithHOC from './action'

function Setting(props) {
  const [tempSetting, setSettings] = useState(defaultFormVal)
  const [tempFields, setFields] = useState([])
  const [deleteIndex, setDeleteIndex] = useState(null) 
  const [tempEditTimeZoneIndex, setTimeZoneIndex] = useState(null)

  const onHandleSubmit = () => {
    if(!props.selectedSetting.id) {
      props.createSetting({
        ... tempSetting,
        dialogue_fields: tempFields
      })
      return
    }

    props.updateSetting({
      ... tempSetting,
      dialogue_fields: tempFields,
      dialogue_operating_timezones: props.selectedOperatingTimeZone 
    })
  }

  useEffect(() => {
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Customer Dialogue System' })

    props.onChangeSettingHOC('subscribedPackage', tmpIndex > -1)
    tmpIndex > -1 && props.getSelectedSetting()
    props.getTranslation()
  }, [])

  useEffect(() => {
    if(props.isTransLoaded) {
      if(props.translations?.[0]) {
        if(props.selectedOperatingTimeZone?.[0]?.language) {
          props.onChangeSettingHOC(
            'selectedOperatingTimeZone', 
            _.map(props.translations?.[0], child => ({
              ... defaultOperatingHours,
              translation_id: child.id
            }))
          )
        } else {
          let tempUnusedTranslation = []
          props.translations.map(child => {
            let tempIndex = _.findIndex(props.selectedOperatingTimeZone, zoneChild =>  zoneChild.translation_id === child.id )
            if(tempIndex < 0) {
              tempUnusedTranslation.push(child)
            }
          })
  
          props.onChangeSettingHOC(
            'selectedOperatingTimeZone', 
            [
              ... props.selectedOperatingTimeZone,
              ... _.map(tempUnusedTranslation, child => ({
                ... defaultOperatingHours,
                translation_id: child.id
              }))
            ]
          )
        }
      } else {
        if(props.selectedOperatingTimeZone.length < 1)
          props.onChangeSettingHOC(
            'selectedOperatingTimeZone', 
            [
              {
                ... defaultOperatingHours,
                language: 'en'
              },
              {
                ... defaultOperatingHours,
                language: 'de'
              },
              {
                ... defaultOperatingHours,
                language: 'it'
              },
              {
                ... defaultOperatingHours,
                language: 'nl'
              }
            ]
          )
      }
    }
  }, [props.translations, props.selectedSetting, props.isTransLoaded])

  useEffect(() => {
    if (props.selectedSetting) {
      setSettings(props.selectedSetting)
      setFields(props.selectedSetting.dialogue_fields)
    }
  }, [props.selectedSetting])

  const onChangeFields = (index, key, val) => {
    let temp = _.cloneDeep(tempFields)

    if(['is_name', 'is_email', 'is_company'].indexOf(key) < 0){
      temp[index][key] = val
    } else {
      temp = _.map(temp, (child, childIndex) => ({
        ... child,
        [key]: childIndex === index ? val : false
      }))
    }
    
    setFields(temp)
  }

  const onDeleteField = (index) => {
    setDeleteIndex(index)
  }

  return (
    <>
      <PageTitle
        heading={Lang['DIALOGS_SETTING'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-headphones icon-gradient bg-happy-itmeo"
        buttons={[]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          { !props.subscribedPackage && <AlertNotSubscribe { ...props } /> }
          <Card className="mb-3">
            <CardHeader>
              {Lang['OPERATING_HOUR_SETTINGS'][props.data.languageReducer.userSettings.admin_panel_language]}
            </CardHeader>
            <CardBody>
              <ReactTable
                showPagination={true}
                defaultPageSize={5}
                NoDataComponent={() => <span></span>}
                data={props.selectedOperatingTimeZone}
                columns={[
                  {
                    Header: Lang['TITLE'][props.data.languageReducer.userSettings.admin_panel_language],
                    accessor: 'translation_id',
                    Cell: row => (
                      <>
                        {
                          props.translations?.[0] 
                            ? <span>{ _.find(props.translations, childTrans => {
                              return childTrans.id === row.original.translation_id
                            })?.slug}</span>
                            : <span>{row.original.language}</span>
                        }
                      </>
                    )
                  },
                  {
                    Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                    accessor: 'id',
                    style: {
                      "justify-content": "center"
                    },
                    Cell: (row, index) => (
                      <>
                        <Button
                          className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                          color='primary'
                          id={`timezone-${row.original.id}-edit-btn`}
                          disabled={ !props.subscribedPackage }
                          onClick={() => {
                            props.onChangeSettingHOC('selectedEditTimeZone', row.original)
                            setTimeZoneIndex(row.index)
                          }} >
                          <i className="pe-7s-pen btn-icon-wrapper" />
                        </Button>
                        <UncontrolledTooltip
                          target={`timezone-${row.original.id}-edit-btn`}
                          placement="top">
                          {Lang['EDIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                        </UncontrolledTooltip>
                      </>
                    )
                  }
                ]}
              />
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <>
                <Form>
                  <MultilingualRTE
                    height={'100px'}
                    isDutchAsRomanian
                    label={Lang['DIALOG_WELCOME_MSG'][props.data.languageReducer.userSettings.admin_panel_language]}
                    value={tempSetting.welcome_message}
                    onChange={val => setSettings({
                      ...tempSetting,
                      welcome_message: val
                    })}
                    selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
                  />
                  <MultilingualRTE
                    height={'100px'}
                    isDutchAsRomanian
                    label={Lang['DIALOG_THANK_MSG'][props.data.languageReducer.userSettings.admin_panel_language]}
                    value={tempSetting.thank_you_message}
                    onChange={val => setSettings({
                      ...tempSetting,
                      thank_you_message: val
                    })}
                    selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
                  />
                  <MultilingualRTE
                    height={'100px'}
                    isDutchAsRomanian
                    label={Lang['OUT_OF_SERVICE_MSG'][props.data.languageReducer.userSettings.admin_panel_language]}
                    value={tempSetting.closed_message}
                    onChange={val => setSettings({
                      ...tempSetting,
                      closed_message: val
                    })}
                    selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
                  />
                  <FormGroup>
                    <Label>
                      {Lang['REMINDER_DURATION'][props.data.languageReducer.userSettings.admin_panel_language]}
                    </Label>
                    <Input
                      value={tempSetting.reminder_duration}
                      onChange={e => setSettings({
                        ...tempSetting,
                        reminder_duration: Number(e.target.value.replace(/[^0-9]/g, ""))
                      })}

                    />
                  </FormGroup>
                </Form>
                <hr />
                <div className="d-flex mb-2">
                  {/* <Label>
                    {Lang['DIALOG_FIELD'][props.data.languageReducer.userSettings.admin_panel_language]}
                  </Label> */}
                  <Button
                    className={'ml-auto'}
                    color={'primary'}
                    onClick={() => {
                      setFields([
                        ...tempFields,
                        dialogueField
                      ])
                    }}
                  >
                    {Lang['ADD_FORM_FIELD'][props.data.languageReducer.userSettings.admin_panel_language]}
                  </Button>
                </div>
                <ListGroup style={{ maxHeight: "100%", overflow: 'scroll' }}>
                  <ListGroupItem>
                    <Row style={{ padding: '7px 0px' }}>
                      <Col md={5}>
                        <span>{Lang['DIALOG_FIELD'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </Col>
                      <Col md={1}>
                        <span>{Lang['SHOW_IN_DIALOG'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </Col>
                      <Col md={1}>
                      <span>{Lang['MANDATORY_FIELD'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </Col>
                      <Col md={1}>
                        <span>{Lang['IS_NAME'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </Col>
                      <Col md={1}>
                        <span>{Lang['IS_EMAIL'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </Col>
                      <Col md={1}>
                        <span>{Lang['IS_COMPANY'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </Col>
                      <Col md={2} className="text-center">
                        <span>{Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                      </Col>
                    </Row>
                    <hr />
                  </ListGroupItem>
                  {
                    tempFields.map((fieldChild, index) => (
                      <ListGroupItem>
                        {
                          index !== 0 && (
                            <hr/>
                          )
                        }
                        <Row>
                          <Col md={5}>
                            <SimpleMultiLang
                              label={''}
                              isDutchAsRomanian
                              inputType={'text'}
                              showLangBar={true}
                              customStyle={{ width: '100%' }}
                              value={tempFields[index].title}
                              onChangeValue={(val) => {
                                onChangeFields(index, 'title', val)
                              }}
                              selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
                            />
                          </Col>
                          <Col md={1} style={{ display: 'flex', justifyContent: 'center' }}>
                            <FormGroup check>
                              <Input
                                type={'checkbox'}
                                checked={tempFields[index]['is_show']}
                                onChange={() => onChangeFields(index, 'is_show', !tempFields[index]['is_show'])}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={1} style={{ display: 'flex', justifyContent: 'center' }}>
                            <FormGroup check>
                              <Input
                                type={'checkbox'}
                                checked={tempFields[index]['is_mandatory']}
                                onChange={() => onChangeFields(index, 'is_mandatory', !tempFields[index]['is_mandatory'])}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={1} style={{ display: 'flex', justifyContent: 'center' }}>
                            <FormGroup check>
                              <Input
                                type={'checkbox'}
                                checked={tempFields[index]['is_name']}
                                onChange={() => onChangeFields(index, 'is_name', !tempFields[index]['is_name'])}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={1} style={{ display: 'flex', justifyContent: 'center' }}>
                            <FormGroup check>
                              <Input
                                type={'checkbox'}
                                checked={tempFields[index]['is_email']}
                                onChange={() => onChangeFields(index, 'is_email', !tempFields[index]['is_email'])}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={1} style={{ display: 'flex', justifyContent: 'center' }}>
                            <FormGroup check>
                              <Input
                                type={'checkbox'}
                                checked={tempFields[index]['is_company']}
                                onChange={() => onChangeFields(index, 'is_company', !tempFields[index]['is_company'])}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={2} className="text-center">
                            <>
                              <Button
                                id={`field-${fieldChild.id}-delete`}
                                className='mb-2 mr-2 btn-icon btn-icon-only'
                                color='danger'
                                onClick={() => onDeleteField(index)}>
                                <i className='pe-7s-trash'> </i>
                              </Button>
                              <UncontrolledTooltip
                                target={`field-${fieldChild.id}-delete`}
                                placement='top'>
                                {Lang['DELETE'][props.data.languageReducer.userSettings.admin_panel_language]}
                              </UncontrolledTooltip>
                            </>
                          </Col>
                        </Row>
                      </ListGroupItem>
                    ))  
                  }
                </ListGroup>

                <div className="d-flex mt-4">
                  <Button
                    className={'ml-auto'}
                    color={'primary'}
                    disabled={ !props.subscribedPackage }
                    onClick={ () => onHandleSubmit() }
                  >
                    {Lang['SUBMIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                  </Button>
                </div>
              </>
            </CardBody>
          </Card>
        </Container>
      </ReactCSSTransitionGroup>
      {
        props.selectedEditTimeZone !== null && (
          <Modal size={'lg'} isOpen={true}>
            <OperatingSlotForm
              lang={props.data.languageReducer.userSettings.admin_panel_language}
              onClose={() => props.onChangeSettingHOC('selectedEditTimeZone', null )}
              selectedEditTimeZone={props.selectedEditTimeZone}
              onSubmit={val => {
                let temp = [ ... props.selectedOperatingTimeZone]
                temp[tempEditTimeZoneIndex] = val

                props.onChangeSettingHOC('selectedEditTimeZone', null )
                props.onChangeSettingHOC('selectedOperatingTimeZone', temp, () => {
                  if(!props.selectedSetting.id) {
                    props.createSetting({
                      ... tempSetting,
                      dialogue_fields: tempFields
                    })
                    return
                  }
              
                  props.updateSetting({
                    ... tempSetting,
                    dialogue_fields: tempFields,
                    dialogue_operating_timezones: temp
                  })
                })
              }}
            />
          </Modal>
        ) 
      }
      {
        deleteIndex !== null && (
          <DeleteConfirmationModal
            handleModalClose={() => setDeleteIndex(null)}
            confirmAction={() => {
              let temp = _.cloneDeep(tempFields)
              temp.splice(deleteIndex, 1)

              setFields(temp)
              setDeleteIndex(null)
            }}
            content={Lang['DELETE_DIALOG_FIELDS'][props.data.languageReducer.userSettings.admin_panel_language]}
            lang={props.data.languageReducer.userSettings.admin_panel_language}
          />
        )
      }
      {
        props.onLoadSettingHOC && <LoadingOverlay/>
      }
    </>
  );
}

export default WithHOC(Setting)